import React, { useEffect, useState } from 'react';
import { NestedApiLocalizationProvider } from 'src/provider/LocalizationProviderConnector';
import { NavItem } from '../mf-utils';
import { LeftSideNav } from './LeftSideNav';
import { useNavItems } from 'src/views/home/HomeWrapper/navItems';
import { useLocation } from 'react-router';

type Props = {
  onNavItemClick: (navItem: NavItem) => void;
};

export function LeftSideNavWrapper(props: Readonly<Props>) {
  const location = useLocation();
  const navItems = useNavItems();
  const [isActive, setIsActive] = useState<NavItem | undefined>(navItems[0]);

  useEffect(() => {
    setIsActive(
      navItems.find((navItem) => navItem.route === location.pathname)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
  return (
    <NestedApiLocalizationProvider preloadResources={['Navigation']}>
      <LeftSideNav
        activeSideNavItem={isActive}
        hoverRequired={true}
        onNavItemClick={props.onNavItemClick}
        setActiveSideNavItem={() => undefined}
        variant="secondary"
      />
    </NestedApiLocalizationProvider>
  );
}
